import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { SyncFlowWorkflow } from '../../../shared/domain/workflows/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/workflows/sync' }

type Params = never

type Body = {
    lastSyncTime: Date
    teams: number[]
    sendAll?: true /** @deprecated No longer need to send as assumed by default */
}

type Query = {
    includeUnitSubjectType?: boolean
    richText?: boolean
    nullDeletedFlows?: boolean
    includeNonConcreteSteps?: boolean
}

type Output = {
    syncTime: Date
    teams: number[]
    workflows: SyncFlowWorkflow[]
}

export type SyncEndpoint = Endpoint<Params, Body, Query, Output>

export const syncRequest = (request: Request, args: RequestArgs<SyncEndpoint>) => request<SyncEndpoint>(route, args)
